import { BaseDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/BaseDesignOption';

export class IconDesignOption extends BaseDesignOption {
  /**
   *
   * @type {boolean}
   */
  show_on_every_page;

  /**
   *
   * @type {string}
   */
  icon_color;

  /**
   *
   * @param model
   */
  constructor(model = {}) {
    super();

    this.show_on_every_page = model.show_on_every_page ?? true;
    this.icon_color = model.icon_color ?? '#000000';
  }
}
